import { render, staticRenderFns } from "./ModalExcluirFamilia.vue?vue&type=template&id=0c67a345"
import script from "./ModalExcluirFamilia.vue?vue&type=script&lang=js"
export * from "./ModalExcluirFamilia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports